import { useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { IQuestionAnswerLocalizedDto } from "../../../interfaces/endpoints/IFAQ";
import {
  createAnswer, createQuestion, deleteAnswer,
  getEntityAnswersWithLocales, updateAnswer, updateQuestion
} from "../../../services/FAQ.service";
import FormWrapper from "../../ui/FormWrapper";
import SpinnerLoader from "../../ui/SpinnerLoader";
import FAQCreator from "../../line-pages/edit/FAQCreator";
import FAQList from "./FAQList";

const QF = 5;
const defaults: IQuestionAnswerLocalizedDto = {
  questionId: 0, answerId: 0,
  localizedQuestions: [{ languageId: 1, question: "" }, { languageId: 2, question: "" }],
  localizedAnswers: [{ languageId: 1, answer: "" }, { languageId: 2, answer: "" }]
};

const EditCityPageFAQ = () => {
  const { id } = useParams<{ id: string }>();
  const [sel, setSel] = useState<IQuestionAnswerLocalizedDto | null>(null);
  const methods = useForm<IQuestionAnswerLocalizedDto>({ defaultValues: defaults });
  const { reset, handleSubmit } = methods;
  const { response, loading, refetch } = useFetch(
    () => getEntityAnswersWithLocales(Number(id), QF), { initRequest: true }
  );
  const faqs: IQuestionAnswerLocalizedDto[] = response?.data || [];

  useEffect(() => {
    if (sel) {
      reset(sel);
    } else {
      reset(defaults);
    }
  }, [sel, reset]);

  useEffect(() => {
    if (response?.data?.length && !sel) {
      setSel(response.data[0]);
    }
  }, [response, sel]);

  const onSubmit: SubmitHandler<IQuestionAnswerLocalizedDto> = async (data) => {
    try {
      if (data.questionId > 0) {
        await updateQuestion(data.questionId, {
          questionFor: QF, locales: data.localizedQuestions
        });
        await updateAnswer(data.answerId, {
          questionId: data.questionId,
          entityId: Number(id),
          entityType: QF,
          locales: data.localizedAnswers
        });
      } else {
        const qRes = await createQuestion({
          questionFor: QF, locales: data.localizedQuestions
        });
        if (qRes?.data?.id) {
          await createAnswer(qRes.data.id, Number(id), QF, {
            locales: data.localizedAnswers
          });
        }
      }
      toast.success("FAQ u ruajt me sukses.", { position: "top-right" });
      setSel(null); reset(defaults); refetch();
    } catch {
      toast.error("Ndodhi një gabim gjatë ruajtjes së FAQ.", { position: "top-right" });
    }
  };

  const handleDel = async (answerId: number) => {
    if (!window.confirm("A jeni të sigurt që doni të fshini këtë FAQ?")) return;
    try {
      await deleteAnswer(answerId);
      toast.success("FAQ u fshi me sukses.", { position: "top-right" });
      if (sel?.answerId === answerId) setSel(null);
      refetch();
    } catch {
      toast.error("Ndodhi një gabim gjatë fshirjes.", { position: "top-right" });
    }
  };

  if (loading) return (
    <div className="min-h-[300px] flex items-center justify-center">
      <SpinnerLoader className="text-primary" />
    </div>
  );

  return (
    <FormProvider {...methods}>
      <div className="flex gap-4">
        <FAQList
          faqs={faqs}
          selectedId={sel?.answerId ?? null}
          onSelect={setSel}
          onAdd={() => {
            setSel(null);
            reset(defaults);
          }}
          onDelete={handleDel}
        />
        <div className="w-2/3">
          <FormWrapper
            onSubmit={handleSubmit(onSubmit)}
            title={sel?.questionId ? "Modifiko FAQ" : "Krijo FAQ të re"}
            showPrompt={false}
          >
            <FAQCreator />
          </FormWrapper>
        </div>
      </div>
    </FormProvider>
  );
};
export default EditCityPageFAQ;
